export default __webpack_public_path__ + "static/hakai_logo.d7d3e95f672f76ccb50956ed7ab2444b.png";